import { makeStyles } from "@material-ui/core/styles"

import Backdrop from "@material-ui/core/Backdrop"
import CircularProgress from "@material-ui/core/CircularProgress"

import AdminFullSizeCell from "./AdminFullSizeCell"

const useStyles = makeStyles({
    backdrop: {
        position: "absolute",
        zIndex: 1,
        backgroundColor: "rgb(255 255 255 / 50%)"
    }
})

export const AdminLoader = props => {
    const classes = useStyles()

    return (
        <AdminFullSizeCell {...props}>
            <Backdrop open className={classes.backdrop}>
                <CircularProgress color="primary" />
            </Backdrop>
        </AdminFullSizeCell>
    )
}

export default AdminLoader
